import React,{useState,useRef,useEffect} from 'react'
import _ from 'lodash'
import { Formik, Field } from 'formik'
import axios from 'axios'
import moment from 'moment'
import DatePicker from "react-datepicker"
import Cleave from 'cleave.js/react'
import parse from 'html-react-parser'

import { ButtonGroup, Form, Input, TextArea, Button, Select, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Search, Segment, FormGroup } from 'semantic-ui-react'

import { WindowReload, WindowURL, WindowLocation, RouteURL, ReportsMPDFUrl, UnliveUpdateFunction } from '../../services/redirect'

import Paginations from '../../services/paginations'
import EntryList from '../../services/entries'

import Spinner from '../../services/spinner'
import AlertMessage from '../../services/alert'
import AlertConfirmation from '../../services/confirmation'
import { DropdownComponent } from '../../components/options'

import ProcessingNotesWindow from './notes_window'

import AuthDenied from '../ErrorPage/denied'

export default function OrdersComponent(props){

  const FormReference = useRef();

  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(true);
  const [statusSpinner,setstatusSpinner] = useState(false);
  const [spinoverlay,setspinoverlay] = useState(false);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
      if(data.reload){
        WindowReload();
      }
    }
  }

  /*------------------------------------------------------
    ALERT MESSAGE NOTIFY
    {intent:'info',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}}
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
      if(data.reload){
        WindowReload();
      }
    }
  }



  /*------------------------------------------------------
    ALERT CONFIRMATION
    {intent:'delete',settings:{id:id,centered:false,onclose:true,icon:'warning',title:'Delete Confirmation!',text:'This process is not ireversible. Once you continue the process, the record will be deleted forever on the database.'}}
  -------------------------------------------------------*/
  const [confirm,setconfirm] = useState(true);
  const [confirmcontent, setconfirmcontent] = useState({});
  function Confirmcallback(data){
    if(data.intent=='close'){
      setconfirm(false);
      if(data.reload){
        WindowReload();
      }
    }
    if(data.intent=='statconfirm'){
      StatusOrderRecord(data.id);
    }
  }


  /*----------------------------------------
    LIST DATA TABLE
  -----------------------------------------*/
  const buttonEl = useRef(null);
  const [buttonclick, setbuttonClick] = useState(0);
  function buttonSubmit(arg){
      setbuttonClick(arg);
      buttonEl.current.click();
  }
  function handleSubmitForm(values, props){

    if(buttonclick==1){
      props.resetForm();
      TableList(defaultpage,search);
    }else{
      let value={
        exact_sent:values.exact_sent,
        product__id:values.product__id,
        account_type:values.account_type,
        product_name:values.product_name,
        order_number:values.order_number,
        account_number:values.account_number,
        account_name:values.account_name,
        product_code:values.product_code,
        status:values.status,
        date_order_from:values.date_order_from!=''?moment(new Date(values.date_order_from)).format('YYYY-MM-DD HH:mm'):'',
        date_order_to:values.date_order_to!=''?moment(new Date(values.date_order_to)).format('YYYY-MM-DD HH:mm'):'',
        quantity:values.quantity,
        process_by:values.process_by
      }

      //console.log(value);
      setpagenumber(defaultpage);
      TableList(defaultpage,value);
    }
  }


  const [search, setsearch]  = useState({
      exact_sent:0,
      product__id:0,
      account_type:'',
      product_name:'',
      order_number:'',
      account_number:'',
      account_name:'',
      product_code:'',
      status:'',
      date_order_from:'',
      date_order_to:'',
      date_order_to_min:'',
      quantity:'',
      process_by:'',
	});


  const [list, setlist] = useState([]);
  const [defaultpage, setdefaultpage] = useState(1);
	const [pagenumber, setpagenumber] = useState(1);
	const [totaldata, settotaldata] = useState(0);
	const [entry, setentry] = useState(0);
	const [entrytype, setentrytype] = useState('');

	const [paginations, setpaginations] = useState({
			paginations:[{
			listnav:[],
			pageinfo:'',
			limit_page:'',
			total_page:'',
			total_records:'',
			current_page:'',
			startPage:'',
			endPage:'',
			ellipseLeft:'',
			ellipseRight:'',
			}]
	});


	  function pagenumberfunction(page){
        //console.log(FormReference.current.values);
        setpagenumber(page);
        let value={
          exact_sent:FormReference.current.values.exact_sent,
          product__id:FormReference.current.values.product__id,
          account_type:FormReference.current.values.account_type,
          product_name:FormReference.current.values.product_name,
          order_number:FormReference.current.values.order_number,
          account_number:FormReference.current.values.account_number,
          account_name:FormReference.current.values.account_name,
          product_code:FormReference.current.values.product_code,
          status:FormReference.current.values.status,
          date_order_from:FormReference.current.values.date_order_from!=''?moment(new Date(FormReference.current.values.date_order_from)).format('YYYY-MM-DD HH:mm'):'',
          date_order_to:FormReference.current.values.date_order_to!=''?moment(new Date(FormReference.current.values.date_order_to)).format('YYYY-MM-DD HH:mm'):'',
          quantity:FormReference.current.values.quantity,
          process_by:FormReference.current.values.process_by

        }
				TableList(page,value);
		}


    function HandleReloadTable(){
        //console.log(FormReference.current.values);
       
        let value={
          exact_sent:FormReference.current.values.exact_sent,
          product__id:FormReference.current.values.product__id,
          account_type:FormReference.current.values.account_type,
          product_name:FormReference.current.values.product_name,
          order_number:FormReference.current.values.order_number,
          account_number:FormReference.current.values.account_number,
          account_name:FormReference.current.values.account_name,
          product_code:FormReference.current.values.product_code,
          status:FormReference.current.values.status,
          date_order_from:FormReference.current.values.date_order_from!=''?moment(new Date(FormReference.current.values.date_order_from)).format('YYYY-MM-DD HH:mm'):'',
          date_order_to:FormReference.current.values.date_order_to!=''?moment(new Date(FormReference.current.values.date_order_to)).format('YYYY-MM-DD HH:mm'):'',
          quantity:FormReference.current.values.quantity,
          process_by:FormReference.current.values.process_by
        }
         
        let page = defaultpage;

        if(value.exact_sent!=0){
           page = pagenumber;
        }
        if(value.product__id!=0){
           page = pagenumber;
        }

        if(value.account_type!=''){
           page = pagenumber;
        }
        if(value.product_name!=''){
           page = pagenumber;
        }
        if(value.order_number!=''){
           page = pagenumber;
        }
        if(value.account_number!=''){
           page = pagenumber;
        }
        if(value.account_name!=''){
           page = pagenumber;
        }
        if(value.product_code!=''){
           page = pagenumber;
        }
         if(value.status!=''){
           page = pagenumber;
        }
         if(value.date_order_from!=''){
           page = pagenumber;
        }
         if(value.date_order_to!=''){
           page = pagenumber;
        }
        if(value.quantity!=''){
           page = pagenumber;
        }

        if(value.process_by!=''){
           page = pagenumber;
        }

        if(pagenumber>1){
           page = pagenumber;
        }
     

        //console.log(page);

        setpagenumber(page);
				TableList(page,value);
        
		}


		function listreload(){
        setpagenumber(defaultpage);
				TableList(defaultpage,search);
		}
    

		function TableList(page,searchstr){

        setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
        setspinner(true);

				let formData = new FormData();
				formData.append('type','list');
				formData.append('search',JSON.stringify(searchstr));
				formData.append('page',page);
				axios.post('/admin/orders/request.php',formData)
				.then(function (response) {
						let obj = response.data;
						setentry(obj.entries.val);
						setentrytype(obj.entries.type);
						setlist(obj.listtable);
						setpaginations(obj.paginations);
						settotaldata(obj.paginations.paginations.total_records);
            setspinner(false);
				})
				.catch(function (error){
          setspinner(false);
				});
	}


  /*------------------------------------------------------
          STATUS FUNCTION
  -------------------------------------------------------*/
  function StatusConfirmation(id,status){

    const data = {
      id:id,
      status:status
    }

    var title = "In Progress Confirmation";
    var text  = "Are you sure you want to mark this order as IN PROGRESS? Please click to confirm to proceed the process.";

    if(status==3){
       title = "Processed Confirmation";
       text  = "Are you sure you want to mark this order as PROCESSED? Please click to confirm to proceed the process.";
    }
    
    if(status==4){
       title = "Back Order Confirmation";
       text  = "Please click to confirm to proceed the process.";
    }

    if(status==5){
       title = "Query Confirmation";
       text  = "Please click to confirm to proceed the process.";
    }

    setconfirmcontent({intent:'confirmation',settings:{id:data,centered:false,onclose:true,icon:'warning',title:title,text:text}});
    setconfirm(true);

  }


  function StatusOrderRecord(data){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:""}});
    setstatusSpinner(true);
    setconfirm(false);

    let formData = new FormData();
    formData.append('type','status');
    formData.append('id',data.id);
    formData.append('status',data.status);
    axios.post('/admin/orders/request.php',formData)
    .then(function (response) {
        let obj = response.data;

        setstatusSpinner(false);

        if(obj=='success'){
          setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Status successfully updated.'}});
          setnotify(true);
          //TableList(pagenumber,search);
          HandleReloadTable();
          setTimeout(function() {
            setnotify(false);
          },2000);
        }else{
          setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Status Failed',text:'Status not successfully updated.'}});
          setnotify(true);
          setTimeout(function() {
            setnotify(false);
          },2000);
        }

    })
    .catch(function (error){
      setstatusSpinner(true);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
    });
}



/*------------------------------------------------------
         SEND ORDER TO EXACT
  -------------------------------------------------------*/
function SendOrderToExact(id){


    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:"Sending order to Exact. Please wait..."}});
    setstatusSpinner(true);
    setconfirm(false);


    let formData = new FormData();
    formData.append('type','send');
    formData.append('order_id',id);
    axios.post('/admin/exact/__order.php',formData)
    .then(function (response) {
        let obj = response.data;

        setstatusSpinner(false);

        setnofitycontent({
          intent:obj.error?'error':'success',
          settings:{
            onclose:true,
            reload:false,
            title:obj.error?'Error Message':'Congratulations',
            text:obj.message
          }
        });
        setnotify(true);

        if(!obj.error){
          //TableList(pagenumber,search);
          //TableList(pagenumber,FormReference.current.values);
          HandleReloadTable();
          setnotify(false);
          //console.log('Yes reload');
        }

        //console.log(obj);
        

        /*if(obj=='success'){
          setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Status successfully updated.'}});
          setnotify(true);
          TableList(pagenumber,search);
          setTimeout(function() {
            setnotify(false);
          },2000);
        }else{
          setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Status Failed',text:'Status not successfully updated.'}});
          setnotify(true);
          setTimeout(function() {
            setnotify(false);
          },2000);
        }*/


    })
    .catch(function (error){
      setstatusSpinner(true);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
    });

}

  /*------------------------------------------------------
   OTHER MODAL
  -------------------------------------------------------*/
  function ClassBody(data){
    if(data){
      document.body.classList.add("modal");
    }else{
      document.body.classList.remove("modal");
    }
  }
  const [isNotes, setIsNotes] = useState(false);
  const [dataNotes, setDataNotes] = useState([]);
  function CallbackFunction(data){
    if(data.close){
      ClassBody(false);
      setIsNotes(false);
    }
  }
  function OpenProcessingNotes(data){
    if(data.length==0){
      return false;
    }
    setDataNotes(data);
    ClassBody(true);
    setIsNotes(true);
  }



  /*------------------------------------------------------
          DROPDOWN OPTIONS
  -------------------------------------------------------*/
  const [orderStatus, setorderStatus] = useState([]);
  const [accountType, setaccountType] = useState([]);
  const [userOptions, setUserOptions] = useState([]);

  const HandleOptions = async () => {
    const source = await DropdownComponent();
    setorderStatus(source.order_status);
    setaccountType(source.account_type);
    setUserOptions(source.user_options);
  }


  /*------------------------------------------------------
        SEARCH SCRIPT
  -------------------------------------------------------*/
  const [searchLoading, setsearchLoading] = useState(false);
  const [searchState, setsearchState] = useState('');
  const [searchResults, setsearchResults] = useState([]);



  /*------------------------------------------------------
         AUTH PERMISSION FOR PAGES
  -------------------------------------------------------*/
  const [loader,setloader] = useState(true);
  const [pageId, setPageId] = useState('49kgqvft618ydxzep');
  const [authPages, setAuthPages] = useState({
    view:0,
    adding:0,
    editing:0,
    deleting:0
  });
  function AuthPagesPermission(){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setloader(true);

    let formData = new FormData();
    formData.append('type','authPages');
    formData.append('id',pageId);
    axios.post('/admin/users-management/users-permission/request.php',formData)
    .then(function (response) {
        let obj = response.data;

        setAuthPages({
          view:obj.view,
          adding:obj.adding,
          editing:obj.editing,
          deleting:obj.deleting,
        });

        // Load page when view permission is granted
        if(obj.view==1){
          TableList(pagenumber,search);
          HandleOptions();
        }
        setloader(false);

    })
    .catch(function (error){
      setloader(false);
      setspinner(true);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
 }

  useEffect(()=>{
    // Load Permission
    AuthPagesPermission();
  },[]);

  return (
    <React.Fragment>



       {confirm&&<AlertConfirmation data={confirmcontent} callback={Confirmcallback}/>}
       {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}

       {loader&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
       {statusSpinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
       {spinoverlay&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}

       {isNotes&&<ProcessingNotesWindow data={dataNotes} callback={CallbackFunction}/>}

       {(authPages['view']==0&&!loader)&&<AuthDenied/>}
       {(authPages['view']==1&&!loader)&&<React.Fragment>


       <div className="app-page-title"><h1>List Orders</h1></div>
       <div className="app-body-wrapper">

       {/*---------------------------------------------------------
          SEARCH SECTION
         --------------------------------------------------------*/}
        <Formik
          initialValues={search}
          onSubmit={handleSubmitForm}
          innerRef={FormReference}
          >
         {({ values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue, setFieldTouched }) => {

         const CustomDateFrom = ({ value, onClick }) => (
           <Input iconPosition='left' onClick={onClick} value={values.date_order_from}><i className='uil-calender icon'></i><input /></Input>
         );
         const CustomDateTo = ({ value, onClick }) => (
           <Input iconPosition='left' onClick={onClick} value={values.date_order_to}><i className='uil-calender icon'></i><input /></Input>
         );

         const handleSearchResultSelected = (e, { result }) => {
            setsearchState(result.title);
            setFieldValue('product_name', result.tile);
            setFieldValue('product__id', result.id);
            buttonSubmit(2);
        }

        const handleSearchChange = (e, { value }) => {

          setsearchState(value);
          setsearchLoading(true);
      
          setTimeout(() => {
          
            if (value.length < 1){
              setsearchState('');
              setsearchLoading(false);
              setsearchResults([]);
              setFieldValue('product__id', 0);
              setTimeout(() => {
              buttonSubmit(2);
              });
              return false;
            }
      
            let formData = new FormData();
            formData.append('type','search_api');
            formData.append('search_string',value);
            axios.post('/include/searchapi.php',formData)
            .then(function (response) {
      
      
              let obj = response.data;
              setsearchResults(obj);
      
              //const re = new RegExp(_.escapeRegExp(value), 'i');
              //const isMatch = (result) => re.test(result.title)
              //setstateResults(_.filter(obj, isMatch));
              setsearchLoading(false);
      
            })
            .catch(function (error){
              setsearchLoading(false);
            });
      
      
          }, 300)
        }



         return(<React.Fragment>
           <div className="search-wrapper">
              <div className="search-body">
                <Form size='mini'>

                  <Form.Group widths="equal">

                      <Field name="product_name">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Product</label>
                              <Input fluid {...field} onChange={(e, { value }) => {
                                
                                   setFieldValue(field.name,value)
                                   TableList(defaultpage,{
                                    exact_sent:0,
                                    product__id:0,
                                    account_type:values.account_type,
                                    product_name:value,
                                    order_number:values.order_number,
                                    account_number:values.account_number,
                                    account_name:values.account_name,
                                    product_code:values.product_code,
                                    status:values.status,
                                    date_order_from:values.date_order_from,
                                    date_order_to:values.date_order_to,
                                    date_order_to_min:values.date_order_to_min,
                                    quantity:values.quantity,
                                    process_by:values.process_by

                                   });
                              }}/>
                            </Form.Field>
                            )}
                      </Field>

                      {/*<Field name="product_name">
                          {({ field, form }) => (
                          <Form.Field>
                            <label>Product</label>
                            <Search
                                fluid
                                input={{ icon: 'search', iconPosition: 'right' }}
                                loading={searchLoading}
                                onBlur={(e ,{ value })=>{
                                  if(values.product__id==0){
                                    setsearchState('');
                                  }
                                }}
                                onResultSelect={handleSearchResultSelected}
                                onSearchChange={_.debounce(handleSearchChange, 500, {
                                    leading: true,
                                })}
                                results={searchResults}
                                value={searchState}
                            />
                          </Form.Field>
                          )}
                        </Field>*/}

                        <Field name="order_number">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Order Number</label>
                              <Input fluid {...field} onChange={handleChange}/>
                            </Form.Field>
                            )}
                          </Field>
                       <Field name="account_number">
                           {({ field, form }) => (
                           <Form.Field>
                             <label>Account Number</label>
                             <Input fluid {...field} onChange={handleChange}/>
                           </Form.Field>
                           )}
                        </Field>
                        <Field name="account_type">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Account Type</label>
                              <Select selectOnBlur={false}
                                  {...field}
                                  options={accountType}
                                  onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                            </Form.Field>
                            )}
                        </Field>
                        {/*<Field name="account_name">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Account Name</label>
                              <Input fluid {...field} onChange={handleChange}  placeholder="Enter hint or word to search"/>
                            </Form.Field>
                            )}
                         </Field>*/}
                    </Form.Group>


                    <Form.Group widths="equal">
                        <Field name="product_code">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Product Code</label>
                              <Input fluid {...field} onChange={handleChange}/>
                            </Form.Field>
                            )}
                         </Field>
                        
                         <Field name="quantity">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Quantity</label>
                              <Cleave {...field} onChange={handleChange} placeholder="Enter number only" options={{numericOnly: true, numeralPositiveOnly: true}} maxLength="10"/>
                            </Form.Field>
                            )}
                         </Field>

                        <Field name="date_order_from">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Date Order From</label>
                              <DatePicker
                                showYearDropdown
                                yearDropdownItemNumber={100}
                                scrollableYearDropdown
                                showMonthDropdown
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={1}
                                dropdownMode="select"
                                selected={values.date_order_from!=''?new Date(values.date_order_from):null}
                                onChange={date => {

                                   console.log(date);

                                   var dateselected 	= moment(new Date(date)).format('DD MMMM YYYY HH:mm');
                                   var formindate 		= moment(new Date(date)).add(0, 'days');
                                   setFieldValue('date_order_to_min',new Date(formindate));
                                   setFieldValue('date_order_from',dateselected);
                                   setFieldValue('date_order_to',dateselected);
                                }}
                                customInput={<CustomDateFrom />}
                              />

                            </Form.Field>
                            )}
                        </Field>
                        <Field name="date_order_to">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Date Order To</label>
                              <DatePicker
                                showYearDropdown
                                yearDropdownItemNumber={100}
                                scrollableYearDropdown
                                showMonthDropdown
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={1}
                                dropdownMode="select"
                                selected={values.date_order_to!=''?new Date(values.date_order_to):null}
                                minDate={values.date_order_to_min}
                                onChange={date => {
                                  var dateselected 		= moment(new Date(date)).format('DD MMMM YYYY HH:mm');
                                  setFieldValue('date_order_to',dateselected);
                                }}
                                customInput={<CustomDateTo />}
                              />
                            </Form.Field>
                            )}
                        </Field>

                        

                    </Form.Group>

                    <FormGroup widths="equal">
                        <Field name="account_name">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Account Name</label>
                              <Input fluid {...field} onChange={handleChange}  placeholder="Enter hint or word to search"/>
                            </Form.Field>
                            )}
                         </Field>
                        <Field name="status">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Status</label>
                              <Select selectOnBlur={false}
                                  {...field}
                                  options={orderStatus}
                                  onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                            </Form.Field>
                            )}
                        </Field>
                        <Field name="process_by">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Processed By</label>
                              <Select
                                  search
                                  selectOnBlur={false}
                                  {...field}
                                  options={userOptions}
                                  onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                            </Form.Field>
                            )}
                        </Field>
                        <Field name="exact_sent">
                            {({ field, form }) => (
                            <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                              <Checkbox style={{'padding-top':'22px'}} checked={values.exact_sent==1} id='exact_sent' label='Hide orders sent to Exact'
                                onChange={e => {
                                  if(e.target.checked){
                                    setFieldValue('exact_sent',1);
                                    buttonSubmit(2);
                                  }else{
                                    setFieldValue('exact_sent',0);
                                    buttonSubmit(2);
                                  }
                                }}
                              />
                              { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="fa fa-exclamation-triangle"></i>{form.errors[field.name]}</Label> }
                            </Form.Field>
                            )}
                        </Field>
                    </FormGroup>


                 </Form>
              </div>
              <div className="search-footer grid">
                <div>
                  <Button type="button" icon='sync alternate' size='tiny' className="LightGrayButton" content='Reset' onClick={() => {
                      setsearchResults([]);
                      setsearchState('');
                      buttonSubmit(1);
                      setpagenumber(defaultpage);
                      TableList(defaultpage,{
                        exact_sent:0,
                        product__id:0,
                        account_type:'',
                        product_name:'',
                        order_number:'',
                        account_number:'',
                        account_name:'',
                        product_code:'',
                        status:'',
                        date_order_from:'',
                        date_order_to:'',
                        date_order_to_min:'',
                        quantity:'',
                        process_by:''
                      });
                    }}/>
                    <Button type="button" icon='search' size='tiny' className="LightGrayButton" content='Search' onClick={() => buttonSubmit(2)}/>
                    <button type="button" style={{'display':'none'}} ref={buttonEl} onClick={handleSubmit}></button>
                  </div>
                  <div>
                  {/*<Form.Group widths="equal">
                      <Form.Field>
                          <Field name="exact_sent">
                              {({ field, form }) => (
                              <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                <Checkbox checked={values.exact_sent==1} id='exact_sent' label='Hide orders sent to Exact'
                                  onChange={e => {
                                    if(e.target.checked){
                                      setFieldValue('exact_sent',1);
                                      buttonSubmit(2);
                                    }else{
                                      setFieldValue('exact_sent',0);
                                      buttonSubmit(2);
                                    }
                                  }}
                                />
                                { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="fa fa-exclamation-triangle"></i>{form.errors[field.name]}</Label> }
                              </Form.Field>
                              )}
                          </Field>
                      </Form.Field>
                    </Form.Group>*/}
                  </div>
              </div>
           </div>
        </React.Fragment>
        )}}
        </Formik>


      {/*---------------------------------------------------------
          TABLE LIST SECTION
         --------------------------------------------------------*/}
      {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}

      {!spinner&&<React.Fragment>
      <div className="tableWrapper">
       <div className="panel-table">

         <div className="panel-table-header">
           <div>{entry>0&&<EntryList entrycallback={entry} entryType={entrytype} lengthCallback={totaldata} callbackreload={listreload}/>}</div>
           <div>
            <Button type="button" className="LightGrayButton" size='tiny' icon='sync alternate' content='Refresh' onClick={() => {
              setsearchResults([]);
              setsearchState('');
              buttonSubmit(1);
              setpagenumber(defaultpage);
              TableList(defaultpage,{
                product__id:0,
                account_type:'',
                product_name:'',
                order_number:'',
                account_number:'',
                account_name:'',
                product_code:'',
                status:'',
                date_order_from:'',
                date_order_to:'',
                date_order_to_min:'',
                quantity:'',
                process_by:''
              });
            }}/>
           </div>
         </div>

         <div className="panel-table-body">
         <div className="table-responsive">
           <Table celled compact='very' className="ordersTable">
             <Table.Header>
               <Table.Row verticalAlign='middle'>
                 <Table.HeaderCell>Date</Table.HeaderCell>
                 <Table.HeaderCell>Order Number</Table.HeaderCell>
                 <Table.HeaderCell>Account Number</Table.HeaderCell>
                 <Table.HeaderCell>Account Type</Table.HeaderCell>
                 <Table.HeaderCell>Pharmacy</Table.HeaderCell>
                 <Table.HeaderCell>Product Code</Table.HeaderCell>
                 <Table.HeaderCell>Product</Table.HeaderCell>
                 <Table.HeaderCell>Quantity</Table.HeaderCell>
                 <Table.HeaderCell>Note</Table.HeaderCell>
                 <Table.HeaderCell>Image</Table.HeaderCell>
                 <Table.HeaderCell></Table.HeaderCell>
               </Table.Row>
             </Table.Header>

            
             <Table.Body>
                   {list.length==0&&<Table.Row negative><Table.Cell  colSpan='10' textAlign="center">No record found</Table.Cell></Table.Row>}
                   {list.map(function(data, key){

                      var tdStyle = {
                        cursor: 'pointer'
                      }

                      if(data.processing_notes.length==0){
                         tdStyle = {}
                      }
                      
                      var classNowrap     = 'now-wrapp ';
                      var classNameStatus = '';
                      if(data.status==1){ classNameStatus =' negative';}
                      if(data.status==2){ classNameStatus =' warning';}
                      if(data.status==3){ classNameStatus =' positive';}
                      if(data.status==4){ classNameStatus =' error';}
                      if(data.status==5){ classNameStatus =' orange';}

                      //negative={data.status==1} warning={data.status==2} positive={data.status==3} error={data.status==4}

                     return <Table.Row key={key} verticalAlign='top'>
                         <Table.Cell className={classNowrap+classNameStatus}>
                            <div className="descriptionTable">
                              <div>
                                  <h3>{data.date_order}</h3>
                                  <p>{data.time_order}</p>
                              </div>
                            </div>
                         </Table.Cell>
                         <Table.Cell className={classNameStatus}>{data.order_number}</Table.Cell>
                         <Table.Cell className={classNameStatus}>{data.account_number}</Table.Cell>

                         <Table.Cell className={classNowrap+classNameStatus}>
                            <div className="descriptionTable">
                              <div>
                                  <h3>{data.account_type}</h3>
                                  <p>{data.reference_code}</p>
                              </div>
                            </div>
                         </Table.Cell>

                         <Table.Cell className={classNameStatus}>{data.account_name}</Table.Cell>
                         <Table.Cell className={classNameStatus}>{data.product_code}</Table.Cell>
                         <Table.Cell className={classNameStatus}>{data.product_name}</Table.Cell>
                         <Table.Cell className={classNameStatus} collapsing>{data.quantity}</Table.Cell>

                         <Table.Cell 
                            style={tdStyle} 
                            collapsing 
                            className={classNameStatus}
                            onClick={()=>OpenProcessingNotes(data.processing_notes)}>
                            {data.processing_notes.length>0&&<i className="uil-comment-alt-exclamation"></i>}
                          </Table.Cell>

                         <Table.Cell collapsing className={classNameStatus}>
                            <a href={data.attachment} target='_blank' rel='noreferrer'><img src={data.attachment} alt=''/></a>
                         </Table.Cell>

                         <Table.Cell collapsing className={classNameStatus}>
                          

                           <Button className='LightBlueButton' size='mini' content='Details'  icon='uil-notes icon' as='a' href={WindowURL('/orders/details/'+data.id)}/>
                           <Button className='BlueButton' size='mini' content='PDF Order'  icon='uil-file-blank icon' as='a' target="_blank" href={ReportsMPDFUrl('/order.php?id='+data.id)}/>
                           <Button disabled={authPages['editing']==0||(data.status>1&&data.status!=5)} className='YellowButton' size='mini' content='In Progress' icon='uil-clock-nine icon' onClick={()=>StatusConfirmation(data.id,2)}/>
                           <Button disabled={authPages['editing']==0||data.status==4||data.status==3} color='purple' size='mini' content='Back Order' icon='uil-calender icon' onClick={()=>StatusConfirmation(data.id,4)}/>

                           <Button disabled={authPages['editing']==0||data.status==5||data.status==3} color='orange' size='mini' content='Query' icon='uil-question-circle icon' onClick={()=>StatusConfirmation(data.id,5)}/>
                           <Button disabled={authPages['editing']==0||data.status==3} className='GreenButton' size='mini' content='Processed' icon='uil-check-circle icon' onClick={()=>StatusConfirmation(data.id,3)}/>
                           <Button title='Send order to Exact' disabled={authPages['editing']==0||data.exact_guid!=''} className='RedButton' size='mini' content='Send Order' icon='uil-layer-group icon' onClick={()=>SendOrderToExact(data.id)}/>
   
                           <div className="infoProcess"><p>{data.info_process}</p></div>
                           

                         </Table.Cell>
                     </Table.Row>
                   })}
               </Table.Body>
               {list.length>0&&
                 <Table.Footer fullWidth>
                     <Table.Row>
                     <Table.HeaderCell colSpan='10'>
                         <div className="dash-footer"><Paginations callbackPagination={paginations} callbackPagenumber={pagenumberfunction}/></div>
                     </Table.HeaderCell>
                     </Table.Row>
                 </Table.Footer>
               }
           </Table>
          </div>{/*.table-responsive*/}
         </div>{/*.panel-table-body*/}
        </div>{/*.panel-table*/}
        </div>

        </React.Fragment>}

       </div>{/*.app-body-wrapper*/}
       </React.Fragment>}
    </React.Fragment>
  )
}
